import { GameStateEnums } from '../../../../../../shared/GameEnums.ts';
import { UIGameMapTileEdgeHoverController } from './UIGameMapTileEdgeHoverController.ts';
import { UIGameMapTileCornerHoverController } from './UIGameMapTileCornerHoverController.ts';
import { ActionState, TurnState } from '@colonist/game-states';
const UIGameEventEnums = GameStateEnums.UIGameEventEnums;
export class UIGameMapHoverController {
    onEvent(data, eventType) {
        switch(eventType){
            case UIGameEventEnums.GameStateUpdated:
            case UIGameEventEnums.DiceStateUpdated:
            case UIGameEventEnums.BeginnerModeActionUpdated:
            case UIGameEventEnums.FinishedBuildingGame:
            case UIGameEventEnums.PlayerControllerStateUpdated:
            case UIGameEventEnums.BeginnerModeInteractWithGuide:
                this.updateHoverState();
                break;
            case UIGameEventEnums.ExchangeCards:
                this.onExchangeCards(data);
                break;
            default:
                break;
        }
    }
    onHoverHighlightClick() {
        this.tileEdgeHoverController.onHoverHighlightClick();
        this.tileCornerHoverController.onHoverHighlightClick();
    }
    onClickInvisibleBackground() {
        this.tileEdgeHoverController.onClickInvisibleBackground();
        this.tileCornerHoverController.onClickInvisibleBackground();
    }
    onHoverHighlightCancellation() {
        this.tileEdgeHoverController.onHoverHighlightCancellation();
        this.tileCornerHoverController.onHoverHighlightCancellation();
    }
    onHoverStateChange() {
        this.tileEdgeHoverController.onHoverStateChange(this.isHoverStateActive);
        this.tileCornerHoverController.onHoverStateChange(this.isHoverStateActive);
    }
    updateHoverState() {
        const updatedHoverState = this.isHoverStateUpdated();
        if (updatedHoverState == this.isHoverStateActive) return;
        this.isHoverStateActive = updatedHoverState;
    }
    isHoverStateUpdated() {
        const validActionStates = [
            ActionState.None
        ];
        if (this.uiGameManager.gameController.currentStateValidator.isSomePlayerInActionState(ActionState.SelectCardsToDiscard) == true) return false;
        if (!this.uiGameManager.gameController.currentStateValidator.currentTurnPlayers.includes(this.uiGameManager.gameController.myColor)) return false;
        const isDiceReset = this.uiGameManager.gameController.currentState.turnState != TurnState.Turn && this.uiGameManager.gameController.diceState.diceThrown == false // ! Turn state check is important here, otherwise build buttons disappear in rush on each dice roll.
        ;
        if (isDiceReset) return false;
        if (this.uiGameManager.gameController.currentState.turnState == TurnState.GameEnd) return false;
        if (!validActionStates.includes(this.uiGameManager.gameController.currentStateValidator.getPlayerActionState(this.uiGameManager.gameController.myColor))) return false;
        return true;
    }
    onExchangeCards(data) {
        const amIExchangingCards = data.givingPlayer == this.uiGameManager.gameController.myColor || data.receivingPlayer == this.uiGameManager.gameController.myColor;
        if (!amIExchangingCards) return;
        this.onClickInvisibleBackground();
    }
    registerTileEdgeHoverAction(hoverAction) {
        this.tileEdgeHoverController.registerHoverAction(hoverAction);
    }
    registerTileCornerHoverAction(hoverAction) {
        this.tileCornerHoverController.registerHoverAction(hoverAction);
    }
    constructor(uiGameManager, shouldHighlightOnlyOnHover){
        this.uiGameManager = uiGameManager;
        this.uiGameManager.eventController.registerUIGameMechanic(this);
        this.isHoverStateActive = false;
        this.tileEdgeHoverController = new UIGameMapTileEdgeHoverController(uiGameManager, shouldHighlightOnlyOnHover);
        this.tileCornerHoverController = new UIGameMapTileCornerHoverController(uiGameManager, shouldHighlightOnlyOnHover);
    }
}
